module.exports = __webpack_public_path__ + "img/right.23172dce.png";